export default function fieldsToFormData(fields: any): FormData {
  const formData = new FormData()
  Object.entries(fields).forEach(([key, value]: any) => {
    if (!value) return

    switch (true) {
      case typeof value === 'number':
        formData.append(key, value.toString())
        break
      case Array.isArray(value):
        formData.append(key, JSON?.stringify(value))
        break
      default:
        formData.append(key, value)
    }
  })
  return formData
}